// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1SILI","title":"BackImages_title__35gwV","images":"BackImages_images__WPAQr"};